import React from 'react';
import styles from './WalletDebitedDetail.module.scss';
import { formatCurrency } from '../formatCurrency';

interface MoneyAmount {
    currency: string;
    amount: number;
}

interface WalletDebitedContext {
    transactionReference: string;
    price: MoneyAmount;
    currentBalance?: MoneyAmount;
    updatedAt?: string;
}

interface WalletDebitedDetailProps {
    context: WalletDebitedContext;
}

const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
};

const formatTime = (dateStr: string): string => {
    const date = new Date(dateStr);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};

const WalletDebitedDetail: React.FC<WalletDebitedDetailProps> = ({ context }) => {
    return (
        <div className={styles.container}>
            <div className={styles.infoBlock}>
                <div className={styles.row}>
                    <span className={styles.rowLabel}>Amount Debited</span>
                    <span className={styles.rowValueDebited}>
                        {formatCurrency(context.price.amount, context.price.currency)}
                    </span>
                </div>
                <div className={styles.row}>
                    <span className={styles.rowLabel}>Current Balance</span>
                    <span className={styles.rowValue}>
                        {context.currentBalance ? formatCurrency(context.currentBalance.amount, context.currentBalance.currency) : 'N/A'}
                    </span>
                </div>
                <div className={styles.row}>
                    <span className={styles.rowLabel}>Date</span>
                    <span className={styles.rowValue}>
                        {context.updatedAt ? `${formatDate(context.updatedAt)} at ${formatTime(context.updatedAt)}` : 'N/A'}
                    </span>
                </div>
            </div>

            <div className={styles.btnContainer}>
                <button className={styles.btn} onClick={() => window.open(`https://www.zepp.com/app/wallet/transactions/${context.transactionReference}`, '_blank')}>
                    View Transaction Details
                </button>
            </div>
        </div>
    );
};

export default WalletDebitedDetail;
